'use client'
import React, { useState } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'

import 'react-pdf/dist/Page/TextLayer.css'
import 'react-pdf/dist/Page/AnnotationLayer.css'

const getWorkerUrl = () => {
  return new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString()
}

pdfjs.GlobalWorkerOptions.workerSrc = getWorkerUrl()

const PdfComponent = ({ pdfFile }) => {
  const [numPages, setNumPages] = useState()
  const [pageNumber] = useState(1)

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages)
  }

  return (
    <div>
      <Document file={pdfFile} onLoadSuccess={onDocumentLoadSuccess}>
        <Page pageNumber={pageNumber} />
      </Document>
      <p>
        Page {pageNumber} of {numPages}
      </p>
    </div>
  )
}

export default PdfComponent
